import React from 'react';
import DockIcon from './DockIcon';

/**
 * Dock区域组件
 */
const DockSection = ({ 
  title, 
  apps, 
  section, 
  maxItems = 3, 
  onIconClick 
}) => {
  // 渲染空图标
  const renderEmptyIcon = (index) => (
    <div 
      key={`empty-${section}-${index}`}
      className="dock-icon empty"
      data-section={section}
      data-empty-index={index}
    >
      <div className="empty-icon"></div>
    </div>
  );

  return (
    <div className={`dock-section ${section}`}>
      <div className="dock-section-label">{title}</div>
      {apps.map(app => (
        <DockIcon
          key={app.id}
          app={app}
          section={section}
          onIconClick={onIconClick}
        />
      ))}
      {[...Array(maxItems - apps.length)].map((_, i) => 
        renderEmptyIcon(i)
      )}
    </div>
  );
};

export default DockSection;
